export const cilTask = ["24 24","<path d='M7.504 8.139l-3.669 3.669 2.907 2.907-0.002 0.002 3.139 3.139 0.534 0.53 3.139-3.139 0.528-0.532 9.481-9.481-3.669-3.669-9.481 9.481zM21.439 5.233l-11.031 11.031-1.548-1.548 0.002-0.002-2.907-2.907 1.548-1.548 2.907 2.907 9.481-9.481z'></path><path d='M21 21.75h-18.75v-18.75h14.073l1.5-1.5h-17.073v21.75h21.75v-14.855l-1.5 1.5v11.855z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-task.js
// module id = null
// module chunks = 